import type { DesktopAppId } from "./apps";

export const beforeDesktopAppCloseEvent = "base-sul-os:before-close-app";
export type DesktopAppCloseDetail = { appId: DesktopAppId; windowId?: string };

/** Editors can veto a user-requested close while dirty/saving. Permission revocation bypasses this guard. */
export function requestDesktopAppClose(appId: DesktopAppId, windowId?: string): boolean {
  return window.dispatchEvent(new CustomEvent<DesktopAppCloseDetail>(beforeDesktopAppCloseEvent, {
    cancelable: true,
    detail: { appId, windowId },
  }));
}
